import { Loading } from 'element-ui';
import { mapGetters } from 'vuex';
import { getAuth, signInWithRedirect, getRedirectResult, signInWithPopup, GoogleAuthProvider, OAuthProvider } from 'firebase/auth';
import { loginWithGoogle } from '@/api/login';
import { getAuthTicket } from '@/api/user';
import firebase from '@/firebase';
import mixins from '@/mixins';
import { addParamsToUrl } from '@/utils/util';

export default {
  name: 'Home',

  mixins: [mixins],

  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },

  computed: {
    ...mapGetters(['appid', 'isLogin', 'redirectURL', 'userToken']),
  },

  methods: {
    init() {
      if (!this.isLogin) {
        return;
      }
      
      this.getAuthTicket();
    },

    async getAuthTicket() {
      const loading = Loading.service({
        fullscreen: true,
        customClass: 'text-loading',
        text: 'Authorizing...'
      });

      try {
        const res = await getAuthTicket({
          token: this.userToken,
          appid: this.appid
        });
        // const ticketEncode = encodeURIComponent(res.data.ticket);
        const redirectURL = addParamsToUrl(decodeURIComponent(this.redirectURL), {
          ticket: res.data.ticket
        });

        window.location.href = redirectURL;
        setTimeout(() => {
          loading.close();
        }, 3000);
      }
      catch(err) {
        console.log(err);
        loading.close();
      }
    },

    async loginGoogle() {
      const loading = Loading.service({
        fullscreen: true,
        customClass: 'text-loading',
        text: 'Logging in...'
      });

      try {
        const provider = new GoogleAuthProvider();
        const authResult = await signInWithPopup(firebase.auth, provider);
        const user = authResult.user;
        const res = await loginWithGoogle({
          uid: user.uid,
          token: user.accessToken,
          appid: this.appid
        });

        // localStorage.setItem(`user_token_${this.appid}`, res.data.token);
        this.$store.dispatch('updateUserToken', {
          userToken: res.data.token
        });
        this.$message({
          message: 'successful',
          type: 'success',
          customClass: 'custom-message',
          showClose: true
        });
        loading.close();
        this.getAuthTicket();
      }
      catch(err) {
        console.log(err);
        loading.close();
      }
    },
  },

  mounted() {
    this.init();
  }
}
